<div id="services-unavailable-container">
  <div class="close">
    <a (click)="close()"> <mat-icon>close</mat-icon></a>
  </div>
  <h2>Let op: Tijdelijk niet beschikbaar</h2>
  <p>
    De {{ appName }} app is op dit moment niet beschikbaar. Dit komt omdat niet alle benodigde diensten om de app correct te laten werken op dit moment beschikbaar zijn.
    Excuses voor het ongemak.
  </p>
  <p>
    Wij controleren periodiek of de benodigde diensten weer beschikbaar zijn. Zodra de diensten weer beschikbaar zijn kan de app weer gebruikt worden. Dit gaat automatisch.
  </p>
  <p>Je kunt ook zelf de de app nu verversen om dit direct te controleren.</p>

  <div class="buttons">
    <a class="button button-secondary" (click)="close()">App verversen</a>
    @if (portalUrl) {
      <a class="button button-primary" (click)="returnPortal()">Terug naar portaal</a>
    }
  </div>
</div>
